import { UserPermission } from '@/modules/permission/enum';
export const stationRoutes = [
    {
        path: '',
        name: 'station',
        exact: true,
        component: () => import('../views/StationIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Check List', label: 'station' }],
            permissions: [UserPermission.READ_CALLSIGN],
        },
    },
];
